import { Box, LinearProgress, Stack } from "@mui/material";
import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import AddUserToClinic from "../../form/AddUserToClinic";
import FullScreenMessageCore from "../../../../../components/fullScreenMessage/FullScreenMessageCore";
import CustomDrawer from "../../../../../components/wrappers/CustomDrawer";
import ToggleDrawer from "../../../../../contexts/ToggleDrawer";
import PageContentWrapper from "../../../../../components/wrappers/PageContentWrapper";
import { useNavigate, useParams } from "react-router-dom";
import { GlobalDataContext } from "../../../../../contexts/GlobalData";
import { ADD_EMPLOYEE_TO_CLINIC } from "../../../../../enums/PermissionTitles";
import ClinicsUsersTable from "./components/ClinicUsersTable";
import { Person } from "@mui/icons-material";
import { useGetEmployees } from "./hooks/useGetEmployees";
import SimpleAlert from "../../../../../components/display/SimpleAlert";
import { HOME } from "../../../../../enums/UrlPaths";
import { useRedirectIfNotOwnClinic } from "../../../../../hooks/useRedirectIfNotOwnClinic";

//Why is this called clinic users...these are employees??
export default function ClinicsUsers() {
  const { id } = useParams();
  useRedirectIfNotOwnClinic(id);
  const { data, loading, error } = useGetEmployees(id);
  const employees = data;
  const numOfUsers = employees?.length;
  const { t } = useTranslation();
  const { isPermissionAllowed } = React.useContext(GlobalDataContext);
  const navigate = useNavigate();
  const isViewAllowed = isPermissionAllowed(ADD_EMPLOYEE_TO_CLINIC);
  
  React.useEffect(()=> {
    if (!isViewAllowed) {
      navigate(HOME);
    }
  }, [isViewAllowed])

  function Form() {
    if (isViewAllowed) {
      return (
        <ToggleDrawer>
          <CustomDrawer
            buttonMessage={t("AddEmployee")}
            buttonSize={"small"}
            variant="contained"
            color="info"
          >
            <AddUserToClinic />
          </CustomDrawer>
        </ToggleDrawer>
      );
    }
  }

  if (loading) {
    return <LinearProgress />;
  } else if (!loading && error) {
    return (
      <SimpleAlert message={"ErrorFetchingEmployeesList"} severity={"error"} />
    );
  }

  if (numOfUsers > 0) {
    return (
      <Wrapper>
        <Stack spacing={2}>
            <Box>
              <Form />
            </Box>
            <ClinicsUsersTable users={employees} />
          </Stack>
      </Wrapper>
    )
  }

  return (
    <Wrapper>
      <PageContentWrapper>
        <FullScreenMessageCore
          shouldCenter={true}
          icon={<Person className="Mui-fullscreen-icon" />}
          title="NoUsers"
        >
          <Form />
        </FullScreenMessageCore>
      </PageContentWrapper>
    </Wrapper>
  );
}


function Wrapper({children}) {
  return (
    <Stack mt={9} ml={2} mr={2} spacing={2}>
      {children}
    </Stack>
  )
}